import React, { useContext } from 'react';
import './Fieldset.css';
import ThemeContext from '../../ThemeContext';
import cs from 'classnames';
function Fieldset(_ref) {
  var id = _ref.id,
    labelledby = _ref.labelledby,
    className = _ref.className,
    children = _ref.children;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cs('_dm-fieldset', '_dm-fieldset--unset', "_dm-fieldset--".concat(theme)),
    role: "group",
    "aria-labelledby": labelledby
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, children));
}

// displayName needs to be explicitly set here so when the code gets mangled
// in production, we can still use this value when checking in other components
Fieldset.displayName = 'Fieldset';
export default Fieldset;